/* eslint-disable no-param-reassign */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISetupStepProps } from ".";
import { filter, pipe } from "callbag-basics";
import subscribe from "callbag-subscribe";
import { useCallback, useEffect, useRef, useState } from "react";
import * as React from "react";
import { useSelector } from "react-redux";

import { Loader } from "@livechat/design-system";

import { ButtonGroup } from "components/button/ButtonGroup";
import { config } from "config/config";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { actions$ } from "store/action-stream";
import {
  EmailDomainActionsNames,
  IEmailDomainUnverified,
  selectEmailDomainVerifyLoading,
} from "store/entities/email-domains";

import { DomainSetupActionType, FinishSetupAction } from "../DomainSetupModal";

import {
  DNSSetupDomainHeader,
  RecordConnectionDetails,
  RecordConnectionDetailsContainer,
  RecordConnectionDetailsDomainConnect,
} from "./components";
import { LoaderWrapper, StyledButton } from "./styles";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const onVerifyFailed = (fn: (IVerifyFailureDomainPayload: any) => void) =>
  pipe(
    actions$,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filter((action: any) => action.type === EmailDomainActionsNames.VERIFY_FAILURE),
    subscribe(fn)
  );

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const onVerifySuccess = (fn: (IVerifySuccessDomainPayload: any) => void) =>
  pipe(
    actions$,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filter((action: any) => action.type === EmailDomainActionsNames.VERIFY_SUCCESS),
    subscribe(fn)
  );

export const SetupDKIMRecords: React.FC<ISetupStepProps<FinishSetupAction>> = ({
  modalAction,
  domains,
  onConfigurationStringCopy,
  setModalAction,
  verifyCustomDomain,
  licenseId,
  manualFlowRef,
  initialFlow,
  setInitialFlow,
}) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const domain = domains?.find((d: any) => d.id === modalAction.domainId);
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingDomain, setLoadingDomain] = useState(false);
  const [failedVerification, setFailedVerification] = useState<IEmailDomainUnverified | null>(null);
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(6133): 'failedRecords' is declared but its value is never... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [failedRecords, setFailedRecords] = useState([]);
  const popupRef = useRef(null);
  const createFailedRef = useRef<boolean | null>(null);
  const timerRef = useRef(null);
  const isEmailDomainVerifyLoading = useSelector(selectEmailDomainVerifyLoading);

  useEffect(() => {
    manualFlowRef.current = null;
    setLoadingDomain(true);

    setTimeout(() => {
      // @ts-expect-error TS(2345)
      verifyCustomDomain(modalAction.domainId, true);
    }, 1500);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      // @ts-expect-error TS(2769): No overload matches this call.
      clearInterval(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const unsubscribe = onVerifySuccess(action => {
      const { id } = action.payload;

      trackEngagement("Domains: Domain added", EventPlace.Settings, { flow: initialFlow, id });

      setModalAction({
        // @ts-expect-error TS(2322)
        type: DomainSetupActionType.DomainAdded,
        customDomain: true,
        domainName: modalAction.domainName,
        domainId: modalAction.domainId,
      });

      return unsubscribe;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const unsubscribe = onVerifyFailed(action => {
      const {
        errorObject: { message, details },
      } = action.payload;
      let error;

      setFailedVerification(details);
      setInitialFlow(details?.dcSyncURL ? "domainConnect" : "manualProvider");

      setLoading(false);
      setLoadingDomain(false);

      if (createFailedRef.current) {
        error = message;
        setValidationError(error);
        trackEngagement("Domains: Domain failed to be connected", EventPlace.Settings);
      } else {
        createFailedRef.current = true;
      }
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalAction]);

  const dnsRecordsReady = domain?.dns;
  // @ts-expect-error TS(2769)
  const dnsRecords = dnsRecordsReady ? Object.entries(domain.dns) : [];

  const cnameDNS = dnsRecords && dnsRecords.find(([key]) => key === "CNAME");
  const txtDNS = dnsRecords && dnsRecords.find(([key]) => key === "TXT");

  const handleDomainVerification = useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      event.preventDefault();
      setLoading(true);
      // @ts-expect-error TS(2345)
      verifyCustomDomain(modalAction.domainId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOpenPopup = () => {
    // @ts-expect-error TS(2322): Type 'Window | null' is not assignable to type 'nu... Remove this comment to see the full error message
    popupRef.current = window.open(
      `${failedVerification?.dcSyncURL}`,
      "popup",
      "width=600,height=600,scrollbars=no,resizable=no"
    );

    setLoading(true);

    // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'null'.
    timerRef.current = setInterval(() => {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      if (popupRef.current.closed) {
        // @ts-expect-error TS(2769): No overload matches this call.
        clearInterval(timerRef.current);
        setLoading(false);
        // @ts-expect-error TS(18048)
        verifyCustomDomain(domain.id);
      }
    }, 1000);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleManualSwitch = () => {
    setInitialFlow("manualProvider");
    setValidationError("");
    trackEngagement("Domains: Switch flow to manual from DomainConnect", EventPlace.Settings);
    manualFlowRef.current = true;
  };

  if (loadingDomain) {
    return (
      <>
        <DNSSetupDomainHeader text="Domain name" domainName={domain?.name} />
        <DNSSetupDomainHeader text="Ownership verification" badge="Verified" />
        <LoaderWrapper>
          <Loader size="large" />
        </LoaderWrapper>
      </>
    );
  }

  return (
    <>
      <DNSSetupDomainHeader text="Domain name" domainName={domain?.name} />
      <DNSSetupDomainHeader text="Ownership verification" badge="Verified" />

      {failedVerification?.dcSyncURL && !manualFlowRef.current && initialFlow === "domainConnect" && (
        <RecordConnectionDetailsContainer>
          <RecordConnectionDetailsDomainConnect
            handleChangeSetup={handleManualSwitch}
            onPopupClick={handleOpenPopup}
            validationError={validationError}
            // FIXME: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            targetDomain={failedVerification as any}
            loading={loading || isEmailDomainVerifyLoading}
          />
        </RecordConnectionDetailsContainer>
      )}

      {dnsRecordsReady && (manualFlowRef.current || initialFlow === "manualProvider") && (
        <RecordConnectionDetailsContainer>
          <RecordConnectionDetails
            // @ts-expect-error TS(2322): Type '[string, unknown] | undefined' is not assign... Remove this comment to see the full error message
            txtDNSRecord={txtDNS}
            // @ts-expect-error TS(2322): Type '[string, unknown] | undefined' is not assign... Remove this comment to see the full error message
            cnameDNSRecord={cnameDNS}
            onCopy={onConfigurationStringCopy}
            validationError={validationError}
            // @ts-expect-error TS(2322)
            targetDomain={failedVerification}
            domainName={domain.name}
            hostname={`${config.customDomainCNamePrefix}${licenseId}.${domain.name}`}
          />
          <ButtonGroup>
            <StyledButton
              size="large"
              kind="primary"
              onClick={handleDomainVerification}
              loading={loading || isEmailDomainVerifyLoading}
            >
              Verify and continue
            </StyledButton>
          </ButtonGroup>
        </RecordConnectionDetailsContainer>
      )}
    </>
  );
};
